import { Container } from '@/components/ui/Container'
import { Section } from '@/components/ui/Section'
import { companyValues } from '@/constants/company'

export function ValuesSection() {
  return (
    <Section surface="0" withBorder>
      <Container>
        <div className="max-w-2xl mb-8 sm:mb-12 md:mb-14">
          <h2 className="text-2xl sm:text-3xl font-bold tracking-tight text-fg">
            Operational Values
          </h2>
          <p className="mt-2 text-sm sm:text-base text-fg-subtle">
            The non-negotiable principles that guide our internal engineering standards and client engagements.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6">
          {companyValues.map((value, idx) => (
            <div
              key={value.id}
              className="p-5 sm:p-6 rounded-sm bg-surface-2 border border-border-subtle flex flex-col justify-between"
            >
              <div>
                <span className="font-mono text-xs text-fg-muted block mb-3">
                  // 0{idx + 1}
                </span>
                <h3 className="text-lg font-semibold text-fg mb-2">
                  {value.title}
                </h3>
                <p className="text-sm text-fg-subtle leading-relaxed">
                  {value.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </Container>
    </Section>
  )
}
